import { useComposerRegistered } from '@/lib/ui/bottomChrome';

/**
 * Story 24.7b — the bottom slot of the flow column (DESIGN.md › Layout &
 * Spacing): an in-flow spacer that reserves the phone toast's height, so the
 * toast covers no content.
 *
 * The toast region stays portalled to `body` (Story 24.3 — an open Sheet makes
 * `#root` inert, and Undo must still work), so the reservation is a CSS
 * variable: the toast card writes `--toast-slot` (its height + 16px) on
 * `<html>` below 1024px, and this spacer takes that height. With no toast the
 * variable is unset and the slot is 0px.
 *
 * Two instances, never both reserving:
 * - MainLayout's, between `<main>` and the tab bar. It renders nothing while a
 *   composer is registered (`useComposerRegistered`).
 * - ChatThreadSurface's (`forComposer`), directly above the composer. It
 *   always renders below 1024px — the composer wins.
 */
export default function BottomSlot({ forComposer = false }: { forComposer?: boolean }) {
  const composerRegistered = useComposerRegistered();
  if (!forComposer && composerRegistered) return null;
  return (
    <div
      aria-hidden="true"
      data-bottom-slot={forComposer ? 'composer' : 'layout'}
      className="lg:hidden shrink-0"
      style={{ height: 'var(--toast-slot, 0px)' }}
    />
  );
}
